/* July Mode PDP (jm-pdp), Reed 2026-10-12: variant picker, color-filtered gallery, mobile dots. */
(function () {
  // Main add-to-cart label. When a Kaching Bundles block is on the page, show the price of the
  // tier that is selected in it (e.g. "$76" for the 3-pack). If the block is there but no tier
  // price can be read yet, show the label without a price. Otherwise use the variant price.
  function atcPriceText(v) {
    var hasKaching = document.querySelector('script.kaching-bundles-product, script.kaching-bundles-deal-block-settings, .kaching-bundles__block');
    if (!hasKaching) return 'Add to cart \u00b7 ' + v.price;
    var sel = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
    var tier = sel ? sel.textContent.trim() : '';
    return tier ? 'Add to cart \u00b7 ' + tier : 'Add to cart';
  }
  function init(root) {
    var dataEl = root.querySelector('[data-jmp-variants]');
    if (!dataEl) return;
    var curV = null; // selected variant when it is available, otherwise null
    var variants = JSON.parse(dataEl.textContent);
    var groups = [].slice.call(root.querySelectorAll('[data-jmp-opt]'));
    var colorIdx = -1;
    groups.forEach(function (g) { if (g.querySelector('.jmp-sw')) colorIdx = +g.getAttribute('data-jmp-opt'); });
    var vid = root.querySelector('[data-jmp-vid]');
    var atc = root.querySelector('[data-jmp-atc]');
    var atcLbl = root.querySelector('[data-jmp-atc-label]');
    var price = root.querySelector('[data-jmp-price]');
    var list = root.querySelector('.jmp-gal__list');
    var cells = list ? [].slice.call(list.children) : [];
    var dots = root.querySelector('.jmp-gal__dots');
    var deskMax = +root.getAttribute('data-desk-max') || 4;
    var mq = window.matchMedia('(max-width: 989px)');

    function selected() {
      var opts = [];
      groups.forEach(function (g) { var c = g.querySelector('input:checked'); opts[+g.getAttribute('data-jmp-opt')] = c ? c.value : null; });
      return opts;
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) if (opts[j] != null && v.options[j] !== opts[j]) ok = false;
        if (ok) return v;
      }
      return null;
    }
    function gallery(color, v) {
      if (!cells.length) return;
      var show = cells.filter(function (c) { return c.dataset.color === color; });
      if (!show.length && v && v.media) show = cells.filter(function (c) { return c.dataset.mid === String(v.media); });
      var limit = mq.matches ? 99 : deskMax, n = 0;
      cells.forEach(function (c) { c.hidden = true; });
      show.forEach(function (c) { if (n < limit) { c.hidden = false; n++; } });
      list.scrollLeft = 0;
      if (dots) {
        dots.innerHTML = '';
        for (var i = 0; i < n; i++) { var s = document.createElement('span'); if (!i) s.className = 'is-on'; dots.appendChild(s); }
      }
    }
    function update(push) {
      var opts = selected();
      groups.forEach(function (g) { var c = g.querySelector('input:checked'); var o = g.querySelector('[data-jmp-optval]'); if (c && o) o.textContent = c.value; });
      // mark unavailable sizes for the chosen color
      groups.forEach(function (g) {
        var idx = +g.getAttribute('data-jmp-opt');
        if (idx === colorIdx) return;
        [].forEach.call(g.querySelectorAll('.jmp-size'), function (l) {
          var t = opts.slice(); t[idx] = l.querySelector('input').value;
          var v = find(t); l.classList.toggle('is-na', !v || !v.available);
        });
      });
      var v = find(opts);
      if (v) {
        var changed = String(vid.value) !== String(v.id);
        vid.value = v.id;
        if (price) price.textContent = v.price;
        if (v.available) { atc.disabled = false; atc.removeAttribute('aria-disabled'); vid.disabled = false; curV = v; atcLbl.textContent = atcPriceText(v); }
        else { atc.disabled = true; atc.setAttribute('aria-disabled', 'true'); curV = null; atcLbl.textContent = 'Sold out'; }
        if (push && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
        // let cart apps (Monster Upsells etc.) that watch the id input see the new variant
        if (changed) {
          try { if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId: root.getAttribute('data-section'), html: null, variant: v } }); } catch (e) {}
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } })); vid.dispatchEvent(new Event('input', { bubbles: true })); vid.dispatchEvent(new Event('change', { bubbles: true })); }
      } else { curV = null; atc.disabled = true; atcLbl.textContent = 'Unavailable'; }
      if (colorIdx > -1) gallery(opts[colorIdx], v || find([opts[colorIdx]]));
    }
    groups.forEach(function (g) { g.addEventListener('change', function () { update(true); }); });
    [].forEach.call(root.querySelectorAll('.jmp-sw'), function (l) {
      l.addEventListener('touchstart', function () {
        root.querySelectorAll('.jmp-sw.is-tap').forEach(function (x) { x.classList.remove('is-tap'); });
        l.classList.add('is-tap'); setTimeout(function () { l.classList.remove('is-tap'); }, 1400);
      }, { passive: true });
    });
    if (list && dots) list.addEventListener('scroll', function () {
      var i = Math.round(list.scrollLeft / list.clientWidth);
      [].forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }, { passive: true });
    mq.addEventListener && mq.addEventListener('change', function () { update(false); });
    update(false);
    // Kaching renders its tiles after page load and changes the selected tier without touching this
    // script, so re-sync the label whenever the DOM changes and on Kaching's deal-bar-selected event.
    var labelQueued = false;
    function syncLabel() {
      labelQueued = false;
      if (!curV) return;
      var text = atcPriceText(curV);
      if (atcLbl.textContent !== text) atcLbl.textContent = text;
    }
    function queueLabel() {
      if (!labelQueued) { labelQueued = true; setTimeout(syncLabel, 0); }
    }
    if (window.MutationObserver) new MutationObserver(queueLabel).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    document.addEventListener('deal-bar-selected', queueLabel);
  }
  function keepView() {
    var p = new URLSearchParams(window.location.search), view = p.get('view'), pt = p.get('preview_theme_id');
    if (!view && !pt) return;
    [].forEach.call(document.querySelectorAll('[data-jmp-stl]'), function (a) {
      var u = new URL(a.href, window.location.origin);
      if (view) u.searchParams.set('view', view);
      if (pt) u.searchParams.set('preview_theme_id', pt);
      a.href = u.toString();
    });
  }
  function kiwiLink() { return document.querySelector('.ks-chart-modal-link, .ks-chart-container a, .ks-chart-container button, [class*="kiwi-sizing"] a'); }
  function kiwiWire() {
    var tries = 0, t = setInterval(function () {
      var k = kiwiLink(); tries++;
      if (k || tries > 40) {
        clearInterval(t);
        [].forEach.call(document.querySelectorAll('[data-jmp-kiwi]'), function (b) { b.hidden = !k; });
        [].forEach.call(document.querySelectorAll('[data-jmp-kiwi-open]'), function (b) { if (!k) b.hidden = true; });
      }
    }, 250);
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jmp-kiwi],[data-jmp-kiwi-open]'); if (!b) return;
      var k = kiwiLink(); if (k) { e.preventDefault(); k.click(); }
    });
  }
  function boot() { kiwiWire(); [].forEach.call(document.querySelectorAll('.jmp-chart__tbl details'), function (d) { d.open = true; }); [].forEach.call(document.querySelectorAll('[data-jmp-main]'), init); keepView();
    if (window.matchMedia('(max-width: 989px)').matches) [].forEach.call(document.querySelectorAll('[data-jmp-fitacc]'), function (d) { d.open = false; });
    if (window.matchMedia('(max-width: 989px)').matches) [].forEach.call(document.querySelectorAll('.jmp-q[open]'), function (d) { d.open = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
